<template>
  <Error :title="title" :message="message">
    <template #actions>
      <Button :label="t('logout')" icon="pi pi-sign-out" @click="logout" />
    </template>
  </Error>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import Error from '@/components/Error.vue'
import { useAuth } from '@/auth/useAuth'

definePage({
  name: 'unauthorized',
  meta: {
    doesNotRequireAuth: true
  }
})

const { t } = useI18n()
const title = t('title')
const message = t('message')
const { logout } = useAuth()
</script>

<i18n lang="yaml">
en:
  title: 'Access Denied'
  message: 'You are not authorised to visit this page. Please contact your Van Vuuren contact person.'
  logout: 'Logout'
nl:
  title: 'Toegang Geweigerd'
  message: 'U bent niet geautoriseerd om deze pagina te bezoeken. Neem contact op met uw Van Vuuren contactpersoon.'
  logout: 'Uitloggen'
  goBack: 'Ga terug'
de:
  title: 'Zugriff Verweigert'
  message: 'Sie sind nicht berechtigt, diese Seite zu besuchen. Bitte wenden Sie sich an Ihren Ansprechpartner bei Van Vuuren.'
  logout: 'Abmelden'
  goBack: 'Zurück'
</i18n>
